import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {Routes, RouterModule} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {AdminModelPage} from './admin-model.page';
import {GlobalModule} from "../../../global-module/global-module.module";
import {AdminPageMenuComponent} from "../../components/tools/admin-page-menu/admin-page-menu.component";
import {AdminGlobalModule} from "../../admin-global-module.module";
import {ScrollingModule} from '@angular/cdk/scrolling';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";

const routes: Routes = [
    {
        path: '',
        component: AdminModelPage
    }
];

@NgModule({
    imports: [
        ScrollingModule,
        CommonModule,
        FormsModule,
        GlobalModule,
        AdminGlobalModule,
        IonicModule,
        RouterModule.forChild(routes)
    ],
    exports: [
        AdminModelPage
    ],
    declarations: [AdminModelPage, AdminPageMenuComponent,]
})
export class AdminModelPageModule {
}
